import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { StripeExpressPaymentRequestButtonComponentDef } from '@df/module-stripe/stripe-express-payment-request-button.component.def';
import { Stripe } from '@df/module-stripe/stripe.namespace';
import { ResultComponent } from '../../ui/resut/result.component';
import { LocalGtmService } from '../gtm/gtm.service.decorator';

@Component({
    selector: 'stripe-express-payment-request-button',
    template: `<div id="container" #container></div>
        <result [status]="totalsUpdatingClickStatus"></result>`,
    styleUrls: ['./stripe-express-payment-request-button.component.scss'],
    standalone: true,
    imports: [ResultComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StripeExpressPaymentRequestButtonComponent extends StripeExpressPaymentRequestButtonComponentDef {
    private gtmService = inject(LocalGtmService);

    protected override onPaymentRequestButtonClickEvent(event: Stripe.IElementInstaceClickEvent): void {
        this.gtmService.push({
            event:
                (this.canMakePaymentResult?.applePay ? 'applepay' : this.canMakePaymentResult?.googlePay ? 'googlepay' : 'link') +
                'express_button_click'
        });
        super.onPaymentRequestButtonClickEvent(event);
    }
}
